<div
  #descriptionElement
  class="description"
  [style.-webkit-line-clamp]="isCollapsed() ? showMaxLines() : null"
>
  @for (paragraph of descriptionParagraphs(); track paragraph) {
    <p class="paragraph">{{ paragraph }}</p>
  }
</div>
@if (isCollapsable()) {
  <button
    type="button"
    class="toggle"
    [aria-label]="isCollapsed() ? 'Expand description' : 'Collapse description'"
    (click)="toggle()"
  >
    {{ isCollapsed() ? '' : 'show less' }}
  </button>
}
